import Loader from '../Loader';
import { SpinnerSize } from '@integration/alexandria-ui';
import { LoaderLabel } from '../LoaderLabel';
import { useSelector } from 'react-redux';
import { applicationSpinnerSelector } from 'redux/selectors/applicationSpinner.selector';

const ApplicationLoader = () => {
  const { isLoading, label } = useSelector(applicationSpinnerSelector);
  return label ? (
    <Loader fullSize blurDepth={SpinnerSize.SMALL} isLoading={isLoading}>
      <LoaderLabel label={label} />
    </Loader>
  ) : (
    <Loader fullSize blurDepth={SpinnerSize.SMALL} isLoading={isLoading} />
  );
};

export default ApplicationLoader;
